import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { productDetailPath } from '~/shared/constants/product';
import useSecondarySite from '~/shared/utils/useSecondarySite';
import { Link } from '~/techstyle-shared/next-routes';
import { useProductDetailContext } from '~/techstyle-shared/react-components';

import ProductReview from '../ProductReview';

const ProductRatingWrapper = styled.div`
  display: block;
  ${({ theme }) => theme.productRatingWrapper};
  ${({ wrapperStyle }) => wrapperStyle}
`;

const countStyle = css`
  margin-left: 4px;
  ${({ theme }) => theme.typography.variants.productRatingCount.textStyle};
  ${({ theme: { reviewsModal } }) => reviewsModal.header.count}
  ${({ theme: { reviewsModal } }) => reviewsModal.header.text}
`;

const ratingStyle = css`
  color: ${({ theme }) => theme.colors.iconColor};
  & svg {
    width: 14px;
  }
`;

export default function ProductRating({
  onProductRatingClick,
  shouldPreventLinking,
  wrapperStyle,
  emptyIcon,
  fullIcon,
  ...rest
}) {
  const { permalink } = useProductDetailContext();
  const secondarySite = useSecondarySite();
  const secondarySitePath = secondarySite ? `/${secondarySite}` : '';

  return (
    <ProductRatingWrapper wrapperStyle={wrapperStyle} {...rest}>
      {shouldPreventLinking ? (
        <ProductReview
          countStyle={countStyle}
          ratingStyle={ratingStyle}
          onClick={onProductRatingClick}
          emptyIcon={emptyIcon}
          fullIcon={fullIcon}
        />
      ) : (
        <Link
          href={`${secondarySitePath}/${productDetailPath}/[identifier]`}
          as={`${secondarySitePath}/${productDetailPath}/${permalink}#reviews`}
        >
          <a>
            <ProductReview
              countStyle={countStyle}
              ratingStyle={ratingStyle}
              onClick={onProductRatingClick}
              emptyIcon={emptyIcon}
              fullIcon={fullIcon}
            />
          </a>
        </Link>
      )}
    </ProductRatingWrapper>
  );
}

ProductRating.propTypes = {
  emptyIcon: PropTypes.node,

  fullIcon: PropTypes.node,

  /* A click handler when the Rating stars are clicked */
  onProductRatingClick: PropTypes.func,

  /* A boolean to prevent rating stars to act as a link */
  shouldPreventLinking: PropTypes.bool,
  /* Anything styled components accepts for styling */
  wrapperStyle: PropTypes.any,
};
